import type { FanficsFilterOptions } from './fetch-fanfics-filter-options.util';
import type { CatalogFilterFacet } from '../types';

export const mergeCatalogFilterOptions = (
  previous: FanficsFilterOptions,
  next: FanficsFilterOptions,
  skippedFacets: CatalogFilterFacet[],
): FanficsFilterOptions => {
  const skipped = new Set(skippedFacets);

  return {
    initialFandoms: skipped.has('fandoms') ? previous.initialFandoms : next.initialFandoms,
    initialStatuses: skipped.has('statuses') ? previous.initialStatuses : next.initialStatuses,
    initialRatings: skipped.has('ratings') ? previous.initialRatings : next.initialRatings,
    initialTags: skipped.has('tags') ? previous.initialTags : next.initialTags,
    initialUniverses: skipped.has('universes') ? previous.initialUniverses : next.initialUniverses,
    initialCharacters: skipped.has('characters')
      ? previous.initialCharacters
      : next.initialCharacters,
  };
};
